import { Flex, Image, Text } from "@chakra-ui/react";
import LogoIcon from "@/assets/logo.png";
import LogoText from "@/assets/logo-text.png";
import Lottie from "lottie-react";
import * as animationData from "@/assets/loading-user.json";

const LogoHome = () => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      height="100%"
      sx={{}}
      flexDir={"column"}
    >
      <Lottie
        animationData={animationData}
        loop={true}
        style={{
          width: "40px",
          height: "40px",
        }}
      />{" "}
      <Text
        sx={{
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 500,
          color: "#FFF",
          marginTop: "12px",
        }}
      >
        Fetching wallet connection
      </Text>
    </Flex>
  );
};

export default LogoHome;
